var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup695(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_695",
    "data-name": "Group 695",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.722,
    height: 35.152,
    viewBox: "0 0 43.722 35.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M-477.177,227.5c.934.68,1.829,1.334,2.727,1.985l9.8,7.095a3.843,3.843,0,0,0,4.9-.028q6.009-4.38,12.025-8.749c.123-.09.242-.187.409-.316-.355-.251-.673-.47-.985-.7a.751.751,0,0,1-.278-1.092.775.775,0,0,1,1.118-.167,6.226,6.226,0,0,1,3.263,5.749c.028,4.648.014,9.3.005,13.946a6.107,6.107,0,0,1-3.92,5.637,1.45,1.45,0,0,1-.221.078.715.715,0,0,1-.883-.441.694.694,0,0,1,.311-.93c.2-.121.419-.207.8-.389a4.257,4.257,0,0,1-.566-.4q-4.645-4.683-9.281-9.375a.834.834,0,0,1-.326-.87.763.763,0,0,1,1.346-.235q2.043,2.055,4.074,4.121,2.784,2.813,5.57,5.623c.087.088.18.171.295.28a4.159,4.159,0,0,0,1.288-2.944c.027-4.837.021-9.674,0-14.511a4.011,4.011,0,0,0-.72-2.206c-.822.6-1.631,1.189-2.436,1.782q-5.058,3.727-10.115,7.457a5.331,5.331,0,0,1-6.439.028l-12.372-8.993c-.125-.09-.256-.172-.42-.282a5.067,5.067,0,0,0-.653,2.437q-.024,7.114,0,14.229a4.384,4.384,0,0,0,1.284,3.009c.127-.119.25-.228.366-.344l9.333-9.39c.111-.111.218-.227.333-.333a.749.749,0,0,1,1.09-.022.72.72,0,0,1-.048,1.083q-2.016,2.048-4.042,4.086-2.671,2.692-5.345,5.382c-.108.109-.211.224-.419.445a16.54,16.54,0,0,0,1.816.213c4.209.017,8.418.009,12.627.009a2.454,2.454,0,0,1,.423.008.717.717,0,0,1,.661.734.72.72,0,0,1-.64.753,1.555,1.555,0,0,1-.329.01h-17.621a1.825,1.825,0,0,1-.329-.007.735.735,0,0,1-.667-.732.728.728,0,0,1,.686-.758c.312-.024.627,0,1.026,0-.125-.168-.207-.288-.3-.4a6,6,0,0,1-1.418-3.94c0-4.6-.008-9.2.006-13.806a6.234,6.234,0,0,1,1.343-4.074,13.22,13.22,0,0,1,2.092-1.8.634.634,0,0,1,.915.189.706.706,0,0,1-.1,1.014C-476.439,226.938-476.792,227.2-477.177,227.5Z",
    transform: "translate(484.898 -215.823)",
    fill: "#575556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M-411.559,128.8q-4.759,0-9.518,0a1.6,1.6,0,0,0-1.783,1.764q0,2.78,0,5.56c0,.627-.285.98-.771.968s-.732-.348-.733-.957q0-2.851,0-5.7a3.083,3.083,0,0,1,3.127-3.137c1.351,0,2.7.008,4.052-.01a1.225,1.225,0,0,0,.641-.205c.75-.515,1.47-1.073,2.217-1.592a4.8,4.8,0,0,1,5.713.034c.715.51,1.408,1.053,2.128,1.555a1.211,1.211,0,0,0,.638.208c1.335.019,2.67,0,4,.011a3.08,3.08,0,0,1,3.108,3.107c.007,1.916,0,3.832,0,5.748,0,.6-.28.939-.752.939s-.751-.343-.752-.939c0-1.869,0-3.738,0-5.607a1.591,1.591,0,0,0-1.754-1.746Q-406.776,128.8-411.559,128.8Zm2.76-1.528a3.573,3.573,0,0,0-5.33,0Z",
    transform: "translate(434.165 -124.568)",
    fill: "#575556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M-383.387,225.5h8.713a2.345,2.345,0,0,1,.423.009.715.715,0,0,1,.652.741.717.717,0,0,1-.648.745,2.2,2.2,0,0,1-.423.01h-17.52c-.11,0-.22.006-.33,0a.77.77,0,0,1-.757-.749.765.765,0,0,1,.753-.751c.125-.009.251,0,.377,0Z",
    transform: "translate(406.006 -215.988)",
    fill: "#575556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M-386.167,265.549h5.176c.648,0,.985.252.994.738s-.334.765-.968.765q-5.247,0-10.493,0c-.549,0-.885-.3-.879-.762s.34-.733.9-.741c.094,0,.188,0,.282,0Z",
    transform: "translate(405.154 -252.262)",
    fill: "#575556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M-306.3,195.03q-2.54,0-5.08,0c-.6,0-.942-.264-.953-.735-.012-.487.339-.768.966-.768q5.08,0,10.16,0c.352,0,.7.053.819.408a.9.9,0,0,1-.035.732,1.1,1.1,0,0,1-.75.352C-302.885,195.045-304.595,195.03-306.3,195.03Z",
    transform: "translate(332.694 -187.025)",
    fill: "#575556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M-253.266,481.539c.689,0,1.378,0,2.067,0,.552,0,.887.293.886.752s-.336.748-.889.75q-2.137.006-4.274,0a.762.762,0,0,1-.862-.729c-.014-.46.323-.767.865-.772C-254.738,481.534-254,481.539-253.266,481.539Z",
    transform: "translate(281.973 -447.896)",
    fill: "#575556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M-118.824,156.587a1.5,1.5,0,0,1-1.523-1.46,1.514,1.514,0,0,1,1.486-1.55,1.517,1.517,0,0,1,1.525,1.465A1.509,1.509,0,0,1-118.824,156.587Z",
    transform: "translate(158.797 -150.843)",
    fill: "#575556"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M-249.671,267.3c-.486,0-.972.011-1.458,0a.74.74,0,0,1-.809-.731.731.731,0,0,1,.743-.755q1.5-.04,3.009,0a.708.708,0,0,1,.748.784.711.711,0,0,1-.776.7C-248.7,267.31-249.185,267.3-249.671,267.3Z",
    transform: "translate(277.986 -252.482)",
    fill: "#575556"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    d: "M-358.458,195c-.359,0-.719.009-1.078,0a.751.751,0,0,1-.8-.741.741.741,0,0,1,.782-.757q1.1-.019,2.2,0a.741.741,0,0,1,.778.762.747.747,0,0,1-.759.735C-357.707,195.013-358.083,195-358.458,195Z",
    transform: "translate(376.17 -186.995)",
    fill: "#575556"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M-102.831,482.974c-.25,0-.5.011-.749,0a.749.749,0,0,1-.755-.738.738.738,0,0,1,.731-.757c.515-.02,1.031-.02,1.546,0a.738.738,0,0,1,.732.758.75.75,0,0,1-.755.738C-102.331,482.985-102.581,482.974-102.831,482.974Z",
    transform: "translate(144.294 -447.827)",
    fill: "#575556"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M-78.84,130.325a.761.761,0,0,1-.75.741.761.761,0,0,1-.752-.785.759.759,0,0,1,.772-.717A.761.761,0,0,1-78.84,130.325Z",
    transform: "translate(122.563 -129.093)",
    fill: "#575556"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M-526.838,418.32a.761.761,0,0,1-.743.748.761.761,0,0,1-.759-.778.759.759,0,0,1,.765-.724A.761.761,0,0,1-526.838,418.32Z",
    transform: "translate(528.339 -389.953)",
    fill: "#575556"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M-174.838,482.316a.762.762,0,0,1-.738.752.761.761,0,0,1-.763-.727.758.758,0,0,1,.761-.775A.76.76,0,0,1-174.838,482.316Z",
    transform: "translate(209.513 -447.923)",
    fill: "#575556"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M-391.6,195.06a.777.777,0,0,1-.739-.761.754.754,0,0,1,.761-.732.755.755,0,0,1,.74.753A.778.778,0,0,1-391.6,195.06Z",
    transform: "translate(405.152 -187.064)",
    fill: "#575556"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M-192.617,267.6a.634.634,0,0,1,.621.586.623.623,0,0,1-.6.605.6.6,0,0,1-.593-.563A.617.617,0,0,1-192.617,267.6Z",
    transform: "translate(224.778 -254.124)",
    fill: "#575556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup695);
export default __webpack_public_path__ + "static/media/Group 695.022cd51e39b28090fbea4a41197399df.svg";
export { ForwardRef as ReactComponent };